export enum AnalyticsApiErrorTypes {
  LoadOrganizationReportsError,
}

export class AnalyticsApiError {
  constructor(public type: AnalyticsApiErrorTypes, public error: Error) {}
}
